import { Directive, Input, HostBinding, ElementRef } from '@angular/core';
import { SubscriptMessage } from './subscript-message';

@Directive({
  selector: '[pgHint], [gritHint]',
  providers: [
    {
      provide: SubscriptMessage,
      useExisting: PgHintDirective,
      multi: true,
    },
  ],
})
export class PgHintDirective implements SubscriptMessage {
  @HostBinding('class') _classList =
    'pg-hint pg-subscript-message grit-hint grit-subscript-message';

  @Input() showWhenFormIsComplete;

  readonly type;
  constructor(public elementRef: ElementRef) {
    this.type = 'hint';
  }
}
